import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { FaUserShield } from "react-icons/fa";
import { loginUser } from "../api/auth";
import { toast } from "react-toastify";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [loginData, setLoginData] = useState({
    username: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginData((prev) => ({ ...prev, [name]: value }));
  };

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await loginUser(loginData);

      if (response?.success) {
        toast.success("Login successful!");

        const backendRole =
          response?.res?.data?.role?.toLowerCase() ||
          response?.res?.data?.user?.role?.toLowerCase();

        const backendUsername =
          response?.res?.data?.adminUsername ||
          response?.res?.data?.username ||
          response?.res?.data?.user?.username ||
          loginData.username;

        localStorage.setItem("adminName", backendUsername);
        localStorage.setItem("adminUsername", backendUsername);

        if (backendRole) localStorage.setItem("role", backendRole);

        const token =
          response?.res?.data?.data ||
          response?.res?.data?.token ||
          response?.res?.data?.accessToken;

        if (token && backendRole) {
          localStorage.setItem(`${backendRole}Token`, token);
          if (backendRole === "admin") {
            localStorage.setItem("adminToken", token);
          }
          localStorage.setItem(`${backendRole}LastActive`, Date.now());
        }

        if (backendRole === "admin") navigate("/admindashboard");
        else if (backendRole === "vip") navigate("/vipdashboard");
        else if (backendRole === "guard") navigate("/guarddashboard");
        else if (backendRole === "user") navigate("/userdashboard");
        else toast.error("Unauthorized role!");
      } else {
        toast.error("Invalid username or password!");
      }
    } catch (err) {
      console.error(err);
      toast.error("Login failed. Try again!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* ===== HOVER ANIMATIONS ===== */}
      <style>
        {`
        /* CARD */
        .glass-card {
          transition: all 0.35s ease;
        }
        .glass-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 35px 80px rgba(0,0,0,0.6);
        }

        /* INPUTS – SAME AS BUTTON FEEL */
        .glass-input {
          transition: all 0.3s ease;
        }

        .glass-input:hover {
          transform: translateY(-2px) scale(1.02);
          background: rgba(255,255,255,0.35);
          border-color: rgba(255,255,255,0.9);
          box-shadow: 0 10px 30px rgba(69,159,244,0.35);
        }

        .glass-input:focus {
          transform: translateY(-2px) scale(1.03);
          background: rgba(255,255,255,0.4);
          box-shadow: 0 0 0 2px rgba(69,159,244,0.6),
                      0 15px 40px rgba(69,159,244,0.5);
        }

        /* BUTTON */
        .primary-btn {
          transition: all 0.3s ease;
        }
        .primary-btn:hover {
          transform: translateY(-2px) scale(1.02);
          box-shadow: 0 15px 40px rgba(69,159,244,0.7);
        }

        .secondary-btn {
          transition: all 0.3s ease;
        }
        .secondary-btn:hover {
          transform: translateY(-2px) scale(1.02);
          background: rgba(255,255,255,0.4);
        }

        .eye-btn {
          transition: all 0.2s ease;
        }
        .eye-btn:hover {
          transform: scale(1.2);
          opacity: 1;
        }
      `}
      </style>

      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundImage: "url('/assets/img/loginPage.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          fontFamily: "Poppins, sans-serif",
        }}
      >
        {/* GLASS LOGIN CARD */}
        <div
          className="glass-card"
          style={{
            width: "90%",
            maxWidth: "420px",
            backdropFilter: "blur(16px)",
            WebkitBackdropFilter: "blur(16px)",
            borderRadius: "16px",
            border: "1px solid rgba(255,255,255,0.3)",
            paddingBottom: "30px",
          }}
        >
          {/* HEADER */}
          <div
            style={{
              background:
                "linear-gradient(135deg, rgba(241, 251, 43, 0.9), rgba(69, 159, 244, 0.7))",
              color: "white",
              padding: "30px 20px",
              borderTopLeftRadius: "16px",
              borderTopRightRadius: "16px",
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontSize: "50px",
                marginBottom: "10px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <FaUserShield />
            </div>
            <h3 style={{ margin: 0, fontWeight: "600", fontSize: "22px" }}>
              Login Here!
            </h3>
          </div>

          {/* FORM */}
          <form onSubmit={handleLogin} style={{ padding: "30px" }}>
            {/* USERNAME */}
            <input
              className="glass-input"
              type="text"
              name="username"
              placeholder="Enter Username"
              value={loginData.username}
              onChange={handleChange}
              required
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "10px",
                border: "1px solid rgba(255,255,255,0.4)",
                background: "#fff",
                color: "black",
                marginBottom: "18px",
                outline: "none",
              }}
            />

            {/* PASSWORD */}
            <div
              style={{
                position: "relative",
                marginBottom: "18px",
                background: "transparent",
              }}
            >
              <input
                className="glass-input"
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Enter Password"
                value={loginData.password}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  padding: "12px",
                  paddingRight: "45px",
                  borderRadius: "10px",
                  border: "1px solid rgba(255,255,255,0.4)",
                  background: "#fff",
                  color: "black",
                  outline: "none",
                }}
              />

              <button
                type="button"
                onClick={togglePasswordVisibility}
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "45%",
                  transform: "translateY(-50%)",
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "20px",
                 // color: "",
                  opacity: 0.85,
                }}
              >
                {showPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
              </button>
            </div>

            {/* LOGIN BUTTON */}
            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%",
                padding: "12px",
                background:
                  "linear-gradient(135deg, rgba(241, 251, 43, 0.9), rgba(69, 159, 244, 0.7)",
                border: "none",
                borderRadius: "10px",
                color: "#fff",
                fontSize: "16px",
                fontWeight: "600",
                cursor: "pointer",
                boxShadow: "0 10px 30px rgba(59,81,227,0.45)",
              }}
            >
              {loading ? "Logging in..." : "Sign In"}
            </button>

            {/* REGISTER */}
            <button
              type="button"
              onClick={() => navigate("/registration")}
              style={{
                marginTop: "10px",
                width: "100%",
                padding: "12px",
                background: "rgba(255,255,255,0.25)",
                border: "1px solid rgba(255,255,255,0.4)",
                borderRadius: "10px",
                color: "#fff",
                fontWeight: "500",
                cursor: "pointer",
              }}
            >
              Registrations
            </button>

            <p
              style={{
                textAlign: "center",
                marginTop: "22px",
                fontSize: "13px",
                color: "rgba(255,255,255,0.8)",
              }}
            >
              ©2025 Dutymanagement.com
            </p>
          </form>
        </div>
      </div>
    </>
  );
}
